<div class="pageCenter">
  <ngb-carousel *ngIf="data">
    <ng-template ngbSlide *ngFor="let dataitem of data">
      <app-dynamic-form [parentData]="dataitem"></app-dynamic-form>
    </ng-template>
  </ngb-carousel>
</div>
